import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { PhoneInput, SipUserInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { PhoneDetailSaveModel } from '../models/phone-detail-save.model';
import { SavePhone, SavePhoneVariables } from '../queries/generated/SavePhone';
import { SavePhoneMutation } from '../queries/save-phone.graphql';
@Injectable({ providedIn: 'root' })
export class AddPhoneApiService {
   addPhoneFields: (keyof PhoneInput)[] = ['phoneType', 'extensionId', 'handsetIpei'];

   editPhoneFields: (keyof PhoneInput)[] = ['phoneId'];

   phoneSipUserField: keyof PhoneInput = 'sipUsers';

   phoneId: keyof PhoneInput = 'phoneId';

   extensionId: keyof PhoneInput = 'extensionId';

   sipUserFields: (keyof SipUserInput)[] = ['sipUserId', 'userName', 'hashPassword', 'accountId'];

   constructor(private apiService: LcsApiService) {}

   save(phoneDetail: PhoneDetailSaveModel): Observable<ExecutionResult<SavePhone>> {
      const fields = [
         ...this.sipUserFields.map((field) => {
            return `${this.phoneSipUserField}.${field}`;
         }),
      ];
      if (phoneDetail.phoneId === 0) {
         fields.push(...this.addPhoneFields);
      }
      return this.apiService.query<SavePhone, SavePhoneVariables>({
         query: SavePhoneMutation,
         variables: {
            phone: {
               ...phoneDetail,
               fields: fields,
               sipUsers: phoneDetail.sipUsers?.map((sipUser) => {
                  return {
                     ...sipUser,
                     fields: this.sipUserFields,
                  };
               }),
            },
         },
      });
   }
}
